import { Card, Typography } from 'antd';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import DepositTransactionHistory from '../../components/DepositTransactionHistory/DepositTransactionHistory';
import PageHeader from '../../components/PageHeader/PageHeader';
import { IUser } from '../../interfaces/Order';
import { RootState } from '../../reducers';
import { IAuthState } from '../../reducers/auth';
import { PageContainer } from '../../styles/Global';
import { $background } from '../../styles/Variables';

const { Title, Text } = Typography;

const DepositInfoCard = styled(Card)`
  margin-bottom: 20px;
  background-color: ${$background};

  .ant-card-body {
    padding: 20px;
  }
`;

const DepositAmount = styled(Text)`
  font-size: 24px;
  font-weight: 600;
  color: #52c41a;
`;

const SellerDepositHistory = () => {
  const { authUser, currentUser } = useSelector(
    (state: RootState) => state.auth as IAuthState
  );

  if (!authUser?.id) {
    return (
      <PageContainer>
        <PageHeader title="Lịch sử giao dịch tiền gửi" />
        <Card>
          <Text type="secondary">Không thể tải thông tin người dùng</Text>
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader title="Lịch sử giao dịch tiền gửi" />

      <DepositInfoCard>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <Title level={4} style={{ margin: 0, marginBottom: 8 }}>
              Số dư hiện tại
            </Title>
            <Text type="secondary">Tài khoản: {currentUser?.username}</Text>
          </div>
          <div style={{ textAlign: 'right' }}>
            <DepositAmount>
              {(
                (currentUser as IUser)?.sellerDeposit?.balance || 0
              ).toLocaleString('vi-VN')}{' '}
              VNĐ
            </DepositAmount>
          </div>
        </div>
      </DepositInfoCard>

      <DepositTransactionHistory userId={authUser.id} />
    </PageContainer>
  );
};

export default SellerDepositHistory;
